import { useNavigate } from "react-router-dom";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton } from "../../shared/styled/global.styled";

const Home = () => {

  const navigate = useNavigate();


  return (
    <LayoutMain idPage="Home">
      <div className="title-options bc-margin-top-3 bc-card-rounded">
        <div className="bc-row">
          <div className="bc-col-6">
            <h2>Bienvenidos a Rekognition</h2>
          </div>
          <div className="bc-col-6">
            <div className="bc-flex bc-justify-content-flex-end">
              <BCButton
                type="button"
                className="bc-button-primary bc-button-small"
                onClick={() => navigate("/rekognition")}
              >
                Analizar imagen
              </BCButton>
              <BCButton
                type="button"
                className="bc-button-secondary bc-button-small"
                onClick={() => navigate("/rekognition-lote")}
              >
                Analizar lote de imagenes
              </BCButton>
            </div>
          </div>
        </div>
        <h4>
          Sistema de aplicativos de analisis de fotografias y piezas publicitarias
        </h4>
        <p>
          <strong>Rekognition</strong> Busca generar interaccion con los usuarios con modelo de analisis de imagenes.
        </p>
      </div>
    </LayoutMain>
  );
};

export default Home;
